import React from 'react'

import config from '../config.js'

import axios from 'axios'

import { Button } from '@material-ui/core/'

import SystemMessageSnackbar from './SystemMessageSnackbar'

class ListFriendInvite extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      invited: false,

      systemMessage: {}
    }
  }

  inviteInternalSend = e => {
    e.preventDefault()

    this.props.sendInternalInvite(
      this.props.aid,
      this.props.fid,
    )
  }

  render() {
    const {
      invited,
      systemMessage
    } = this.state

    let imgUrl = config.baseUrl + '/assets/img/generic-avatar-medium.png';
    if (this.props.avatarUrl !== null && this.props.avatarUrl !== undefined && this.props.avatarUrl !== '') {
      // console.log("ListFriendInvite.render: this.props.avatarUrl is defined: [" + this.props.avatarUrl + "]");
      imgUrl = this.props.avatarUrl + '=s96-c';
    }

    return (
      <li className="friends-list-item">
        <img
          className="friends-list-item__img"
          src={imgUrl}
          alt={this.props.name + ' Avatar'}
        />
        <h3 className="friends-list-item__name">{this.props.name}</h3>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={invited}
          onClick={e => {
            this.inviteInternalSend(e)
          }}
        >
          Invite
        </Button>
        <SystemMessageSnackbar systemMessage={systemMessage} />
      </li>
    )
  }
}

export default ListFriendInvite



// WEBPACK FOOTER //
// ./src/Components/ListFriendInvite.js